<div *ngIf="$loaderEvent | async" class="spinner ml-1 center">
  <mat-spinner [diameter]="50"></mat-spinner>
</div>
